import { connect } from "react-redux";
import Scorecard from "../components/Scorecard";
import { getScorecard, getScorecardChart, getScorecardDistributor, getScorecardChartPersona, getAgencyProductListPersona, getAgentList } from "../store/actions/authActions";

const mapStatetoProps = (state) => ({
  applicationsSubmitted: state.auth.applicationsSubmitted,
  approvalRate: state.auth.approvalRate,
  chartTotals: state.auth.chartTotals,
  displayFlag: state.auth.displayFlag,
  excessiveApplicationActivity: state.auth.excessiveApplicationActivity,
  fourMonthLapseRate: state.auth.fourMonthLapseRate,
  freeLookCancel: state.auth.freeLookCancel,
  msgCode: state.auth.msgCode,
  msgText: state.auth.msgText,
  policiesIssued: state.auth.policiesIssued,
  productId: state.auth.productId,
  qualityScore: state.auth.qualityScore,
  statusCode: state.auth.statusCode,
  underwritingInaccuracy: state.auth.underwritingInaccuracy,
  isAuthenticated: state.auth.isAuthenticated,
  userSourceCode: state.auth.userSourceCode,
  relationalType: state.auth.relationalType,
  agentList: state.auth.agentList,
  agencyList: state.auth.agencyList,
  productList: state.auth.productList,
  distributorList: state.auth.distributorList
})

const ScorecardContainer = connect(mapStatetoProps, {
  getScorecard,
  getScorecardChart,
  getScorecardDistributor,
  getScorecardChartPersona,
  getAgencyProductListPersona,
  getAgentList
})(({ ...props }) => <Scorecard {...props}></Scorecard>)

export default ScorecardContainer;
